<template>
    <div>
        <div class="row">
            <div class="col-12 no-inner-padding">
                <div class="search-items__box">
                    <input
                        v-model="currentSearchTerm"
                        type="text"
                        class="search-items__input"
                        @keyup.enter="searchPage"
                    />
                    <button class="search-items__button" @click="searchPage">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="row py-lg-4">
            <NewsCard
                v-for="newsItem in items"
                :key="newsItem.id"
                :news-item="newsItem"
            ></NewsCard>
        </div>
        <div
            v-show="showMore"
            class="py-3 row block-news-overview_button-row text-center"
        >
            <button
                class="btn btn-primary mx-auto"
                name="load-more"
                @click="nextPage"
            >
                Meer nieuws laden
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import NewsCard from '@/components/news/news-card';

export default {
    components: {
        NewsCard
    },
    props: {
        urlPart: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            items: [],
            showMore: false,
            page: 1,
            currentSearchTerm: '',
            searchTerm: '',
            required: false
        };
    },
    watch: {
        page() {
            this.getItems();
        },
        searchTerm() {
            this.setHash('q', this.currentSearchTerm);
            if (this.page != 1) {
                this.page = 1;
            } else {
                this.getItems();
            }
        }
    },
    created() {
        const searchTerm = this.getHashValue('q');
        if (searchTerm) {
            this.currentSearchTerm = decodeURI(searchTerm);
            this.searchPage();
        } else {
            this.getItems();
        }
    },
    methods: {
        getItems() {
            axios({
                method: 'get',
                url:
                    '/api/' +
                    this.urlPart +
                    '/list?' +
                    this.$root.settings.nodeId +
                    '&page=' +
                    this.page +
                    '&searchTerm=' +
                    this.searchTerm
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.items = this.items.concat(response.data.pagedResults);
                    this.showMore = response.data.showMore;

                    return true;
                })
                .catch(() => false);
        },
        nextPage() {
            this.page += 1;
        },
        searchPage() {
            if (this.searchTerm !== this.currentSearchTerm) {
                this.items = [];
                this.searchTerm = this.currentSearchTerm;
            } else {
                this.items = [];
                this.page = 1;
            }
        },
        hashChanged() {
            const searchTerm = this.getHashValue('q');
            if (searchTerm) {
                this.currentSearchTerm = searchTerm;
                this.searchPage();
            } else {
                this.currentSearchTerm = '';
                this.searchPage();
            }
        },
        getHashValue(prop) {
            if (window.location.hash) {
                const hash = window.location.hash.substr(1);
                const result = hash.split('&').reduce(function(res, item) {
                    const parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                return result[prop];
            } else {
                return null;
            }
        },
        setHash(prop, val) {
            window.location.hash = prop + '=' + val;
        }
    }
};
</script>

<style lang="scss" scoped>
.block-news-overview_button-row {
    background-color: $color-gray;
}
</style>
